module.exports = __webpack_public_path__ + "assets/6917dd63f7aeb770a5cab5cbe5b214ff.png";